import { ROUTES } from '@aibees/elephant/router';
import { SearchMode } from '@aibees/elephant/types';
import { Icon } from '@aibees/shared/components';
import { KeyCodes } from '@aibees/shared/definition';
import { classnames } from '@aibees/shared/utils';
import { Button, Stack, TextFieldProps } from '@mui/material';
import { memo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as Styled from './styles';
import * as SX from './sx';
import type { SemanticSearchProps as Props } from './types';

export const SemanticSearch = memo(({ className }: Props) => {
  const [semanticSearch, setSemanticSearch] = useState<string>('');
  const navigate = useNavigate();

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSemanticSearch(event.target.value);
  };

  const handleSubmit = () => {
    navigate(
      `${ROUTES.searchCompany}?type=${SearchMode.Semantic}&value=${semanticSearch}`
    );
  };

  const handleKeyDown: TextFieldProps['onKeyDown'] = (event) => {
    if (event.key === KeyCodes.enter && semanticSearch.length > 0) {
      handleSubmit();
    }
  };

  return (
    <Styled.Wrapper
      className={classnames('SemanticSearch', className)}
      sx={SX.root}
      direction="row"
      gap={1}
    >
      <Stack sx={SX.searchBox} direction="row" alignItems="center" gap={1}>
        <Icon name="search" sxx={SX.icon} />
        <Styled.SearchInput
          value={semanticSearch}
          onChange={handleSearchChange}
          onKeyDown={handleKeyDown}
          sx={SX.input}
          placeholder="e.g, Accounting Software"
        />
      </Stack>
      <Button
        variant="contained"
        color="primary"
        sx={SX.button}
        disabled={!semanticSearch}
        onClick={handleSubmit}
      >
        <Icon name="arrow-right-fill" />
      </Button>
    </Styled.Wrapper>
  );
});

SemanticSearch.displayName = 'SemanticSearch';
